import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { WebsiteApp } from './web-test/WebsiteApp'
import { bootWebsiteTheme } from './web-test/website-theme'
import './web-test/web-test-tokens.css'
import './styles/tokens.css'
import './styles/base.css'
import './shared/brand-logo.css'

bootWebsiteTheme()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <WebsiteApp />
    </BrowserRouter>
  </StrictMode>,
)
